import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import IssuanceService from "../../../API/orders/prodaction.issueedge/issuance/IssuanceService";
import IssuanceWarehouseMaterialTable
    from "../../../components/UI/table/prodaction/issue/IssuanceWarehouseMaterialTable";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../Constants";

const IssuanceIssuingEdgesItem = () => {
    const pathname = useLocation().pathname
    const params = useParams();
    const [data, setData] = useState([]);
    const profile = JSON.parse(localStorage.getItem("profile"))
    const {baseCurAbbreviation, alternativeCurAbbreviation} = profile
    const id = params.id
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    useEffect(() => {
        getStartPageSize()
        IssuanceService.getAllByIssuingEdgeItemId(id).then(function (response) {
            const data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Выдано"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Выдано
                    </Typography>
                </Box>
                <IssuanceWarehouseMaterialTable
                    data={data}
                    setData={setData}
                    baseCurrency={baseCurAbbreviation}
                    alternativeCurrency={alternativeCurAbbreviation}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    issuingEdges={true}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default IssuanceIssuingEdgesItem;